export default __webpack_public_path__ + "static/media/colored-quiz-icon.b172c248.svg";